import { render, staticRenderFns } from "./categoryForm.vue?vue&type=template&id=49153602"
import script from "./categoryForm.vue?vue&type=script&lang=js"
export * from "./categoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports